module.exports = __webpack_public_path__ + "img/lp2-shifting-investment.2ea10b44.png";